import { createAction } from '@reduxjs/toolkit';
import { GET_DICTIONARIES_INDUSTRIES } from '../actionConstants';

export const getAllIndustriesAction = createAction(GET_DICTIONARIES_INDUSTRIES);
